<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'ops-notification-rule-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs></sbnb-page-header>
    </app-feature-flag-tabs>

    <ng-container *ngIf="ruleSetData; else loading">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
        <div fxFlex fxLayoutAlign="start center" fxLayoutGap="16px">
          <mat-slide-toggle
            [checked]="ruleSetData.active"
            (click)="$event.stopPropagation()"
            (change)="activateOrDeactivateRule($event)"></mat-slide-toggle>

          <h2 fxFlex class="nomargin input__editable">
            <input
              #nameInput
              class="input__borderless"
              type="text"
              [style.width.px]="nameInput.value.length * 13"
              [(ngModel)]="ruleSetData.name"
              (change)="save()" />
          </h2>

          <sbnb-cs-debug-item
            label="Notification Rule ID"
            [coreNovaLink]="'/resources/rulesets/' + ruleSetData.id"
            [value]="ruleSetData.id"
            linkLabel="Nova"></sbnb-cs-debug-item>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <div class="team__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
          <h3 class="nomargin" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <sbnb-icon icon="message" class="text-smoke-darker"></sbnb-icon>
            <span>Message</span>
          </h3>
          <span fxHide.lt-md class="card__collapsed-helper-text">
            The message that will be sent to your teammates. You can use short codes and custom codes by typing %.
          </span>
        </div>

        <div fxLayout fxLayoutGap="24px" style="margin-bottom: 20px">
          <div
            fxFlex
            class="selection__box"
            [class.selection__box-selected]="ruleSetData.team.notify_via === 'email'"
            fxLayout="column"
            fxLayoutGap="16px"
            (click)="ruleSetData.team.notify_via = 'email'; save()">
            <strong>Email notification</strong>
            <div class="text__small">Notify your team with an email.</div>
          </div>

          <div
            fxFlex
            class="selection__box"
            [class.selection__box-selected]="ruleSetData.team.notify_via === 'sms'"
            fxLayout="column"
            fxLayoutGap="16px"
            (click)="ruleSetData.team.notify_via = 'sms'; save()">
            <strong>SMS notification</strong>
            <div class="text__small">Notify your team with a SMS message.</div>
          </div>
        </div>

        <sbnb-rule-editor
          #ruleEditor
          [importEnabled]="false"
          [previewEnabled]="true"
          [ruleSetId]="ruleSetId"
          [ruleType]="ruleSetData.event"
          [ruleSetData]="ruleSetData"
          [emailSubject]="ruleSetData.team.notify_via === 'email' ? true : false"
          (saveStatusChange)="ruleSaveStatusChange($event)"></sbnb-rule-editor>
      </div>

      <div
        *ngIf="ruleSetData.event === 'team:checkin' || ruleSetData.event === 'team:checkout'"
        class="rule__section-container rule__section-collapsed">
        <div fxLayout fxLayoutAlign="start center">
          <h3
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            style="margin-top: 0; margin-bottom: 0; padding-right: 40px"
            class="not-clickable">
            <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>Timing</span>
          </h3>
          <sbnb-rule-timing
            *ngIf="timingsMeta && ruleSetData"
            [meta]="timingsMeta"
            [ruleset]="ruleSetData"
            (triggerSave)="timingUpdated($event)"></sbnb-rule-timing>
        </div>
      </div>

      <div class="team__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
          <h3 class="nomargin" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <img src="/assets/iconography/settings.svg" width="20" height="20" />
            <span>Settings</span>
          </h3>
          <span class="card__collapsed-helper-text">Fine-tune preferences for this rule.</span>
        </div>

        <sbnb-rule-settings
          [settings]="ruleSetData.team"
          [rulesetType]="ruleSetData.event"
          [notifyVia]="ruleSetData.team.notify_via"
          (updated)="handlesettingsChange($event)"></sbnb-rule-settings>
      </div>

      <div class="team__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
          <h3 class="nomargin" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <img src="/assets/iconography/team.svg" width="20" height="20" />
            <span>{{ isTaskNotification ? 'Task Type' : 'Team' }}</span>
          </h3>
          <span class="card__collapsed-helper-text">
            {{
              isTaskNotification
                ? 'please choose the task types that will trigger this notification rule.'
                : 'Please choose the team you want to notify.'
            }}
          </span>
        </div>

        <div *ngIf="possibleRoles && !isTaskNotification" fxLayout="row wrap">
          <mat-checkbox
            fxFlex="200px"
            *ngFor="let role of possibleRoles"
            [checked]="ruleSetData.team.services.indexOf(role.id) > -1"
            (change)="roleChange(role, $event)">
            <span>{{ role.name }}</span>
          </mat-checkbox>
        </div>

        <div *ngIf="isTaskNotification" fxLayout="row wrap">
          <mat-checkbox
            fxFlex="200px"
            *ngFor="let role of taskRoles"
            [checked]="ruleSetData.team.services.indexOf(role.id) > -1"
            (change)="roleChange(role, $event)">
            <span>{{ role.name }}</span>
          </mat-checkbox>
        </div>
      </div>

      <div class="team__section-container">
        <div class="team__header" fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
          <h3 class="nomargin" fxLayout fxLayoutAlign="start center" fxLayoutGap="16px">
            <sbnb-icon icon="scope" [size]="20" class="text-smoke-darker"></sbnb-icon>
            <span>Scope</span>
          </h3>
          <span class="card__collapsed-helper-text">Select the properties this task will be available for.</span>
        </div>

        <div class="rule__scope-box">
          <div fxLayout fxLayoutAlign="space-between center" fxLayoutGap="4px" class="rule__scope-header">
            <mat-checkbox [checked]="ruleSetData.all_properties" (change)="allPropertyChange($event)">
              <h4 fxFlex>Properties</h4>
            </mat-checkbox>
            <span *ngIf="!ruleSetData.all_properties">{{ ruleSetData.properties?.length }} selected</span>
            <span *ngIf="ruleSetData.all_properties">All properties</span>
          </div>
          <div
            [style.opacity]="ruleSetData.all_properties ? 0.2 : 1"
            [style.pointer-events]="ruleSetData.all_properties ? 'none' : null">
            <div>
              <sbnb-search-bar
                placeholderText="Search..."
                (searchChanged)="propertySearchChanged($event)"></sbnb-search-bar>
            </div>
            <cdk-virtual-scroll-viewport itemSize="40" class="rules__scrollable">
              <ng-container *cdkVirtualFor="let property of displayProperties" trackBy="propertyTrackby">
                <div>
                  <mat-checkbox
                    style="width: 100% !important"
                    [checked]="ruleSetData.all_properties || ruleSetData.properties.indexOf(property.id) > -1"
                    (change)="propertyCheckboxChange(property, $event)">
                    <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
                      <img [src]="property.picture" class="property__img" />
                      <span fxFlex class="ellipsis">{{ property.name }}</span>
                    </span>
                  </mat-checkbox>
                </div>
              </ng-container>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
      </div>

      <div class="team__section-container" fxLayout fxLayoutAlign="start center">
        <button class="button__text ocean" mat-flat-button (click)="deleteRulesetPrompt()">
          <img src="/assets/iconography/delete.svg" style="margin-right: 6px" />
          <span>Delete</span>
        </button>
        <button class="button__text ocean" mat-flat-button (click)="copyRuleset()">
          <img src="/assets/iconography/copy.svg" />
          Copy
        </button>

        <span fxFlex></span>

        <div fxLayout fxLayoutAlign="end center">
          <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
        </div>
      </div>
    </ng-container>

    <ng-template #loading>
      <mat-spinner [diameter]="30"></mat-spinner>
    </ng-template>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
